<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>网站配置</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/config/menus">菜单设置</el-breadcrumb-item>
        <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>菜单列表</span>
        </div>
        <el-button @click="dialogFormVisible = true" size="small" icon="el-icon-plus" type="primary">添加菜单</el-button>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" size="mini" style="width: 100%" row-key="menu_id" v-loading="loading" default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <!-- <el-table-column prop="menu_id" label="ID" width="100"></el-table-column> -->
          <el-table-column prop="name" label="标题" width="200"></el-table-column>
          <el-table-column prop="icon" label="图标" width="160"></el-table-column>
          <el-table-column prop="url" label="URL" width="160"></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column label="操作权限" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.operate" :active-value="1" :inactive-value="0" @change="setStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="display_order" label="排序" width="50"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.menu_id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.menu_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
      </div>
    </div>

    <el-dialog title="菜单管理" width="40%" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="选择父级" :label-width="formLabelWidth" prop="parent_menu_id">
          <el-select v-model="ruleForm.parent_menu_id" placeholder="选择父级">
            <el-option label="顶级" :value="0"></el-option>
            <el-option v-for="(item, index) in cateList" :key="index" :label="item.name" :value="item.menu_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单标题" :label-width="formLabelWidth" prop="name">
          <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单URL" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单ICON" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.icon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单归属" :label-width="formLabelWidth">
          <el-checkbox-group v-model="ruleForm.menu_right">
            <el-checkbox label="1">平台</el-checkbox>
            <el-checkbox label="2">代理商</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="操作权限" :label-width="formLabelWidth">
          <el-radio-group v-model="ruleForm.operate">
            <el-radio :label="1">有</el-radio>
            <el-radio :label="0">无</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单排序" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.display_order" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      cateList: [],
      page: 1,
      count: 0,
      limit: 30,
      dialogFormVisible: false,
      ruleForm: {
        parent_menu_id: "",
        name: "",
        menu_right: [],
        url: "",
        operate: "",
        display_order: "",
        icon: "",
      },
      rules: {
        parent_menu_id: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      formLabelWidth: "90px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getCate();
  },
  methods: {
    getCate() {
      var that = this;
      that.axios.post("/menus/getCate").then((res) => {
        if (res) {
          that.cateList = res.data;
        }
        that.loading = false;
      });
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/menus/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    setStatus(row) {
      var that = this;
      that.axios
        .post("/menus/status", { id: row.id, status: row.status })
        .then((res) => {});
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("/menus/destroy", {
            ids: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.pageNum = that.page;
      formData.pageSize = that.limit;
      that.axios.post("/menus/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data;
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/menus/store";
        if (that.id) {
          formData.id = that.id;
          url = "/menus/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.ruleForm.pid = "";
          that.ruleForm.thumb = "";
          that.ruleForm.zh_title = "";
          that.ruleForm.en_title = "";
          that.ruleForm.sort = "";
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>